import React from 'react';
import PropTypes from 'prop-types';
import Button from '@nubank/nuds-web/components/Button/Button';

import { StickyContainer } from './style';

function DrawerToggleButton(props) {
  const { onToggleRegistration, buttonLabel, ...rest } = props;

  return (
    <StickyContainer>
      <Button
        id="widget-toggle-button"
        onClick={onToggleRegistration}
        extended
        data-open-widget-button-index="2"
        {...rest}
        intlKey={buttonLabel}
      />
    </StickyContainer>
  );
}

DrawerToggleButton.propTypes = {
  buttonLabel: PropTypes.string.isRequired,
  onToggleRegistration: PropTypes.func.isRequired,
};

export default DrawerToggleButton;
